<template>
    <el-dialog title="高考信息" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-infor gk-infor">
        <img src="../assets/images/tuoyuan.png" alt="背景图" class="dialog-img">
        <el-form :model="ruleForm" ref="ruleForm" :rules="rules" :label-width="formLabelWidth">
            <!-- <el-form-item label="高考省份：" prop="province" class="dialog-province">
                <el-select v-model="ruleForm.province" placeholder="请选择高考省份" @change="$forceUpdate()">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item label="高考省份：" prop="province" class="dialog-province el-form-item-diff">
                <el-input v-model="ruleForm.province_name" autocomplete="off" placeholder="" disabled/>
            </el-form-item>
            <el-form-item label="科目组合：" prop="subject_name" class="dialog-province el-form-item-diff">
                <el-input v-model="ruleForm.subject_name" autocomplete="off" placeholder="" disabled/>
                <!-- <el-button v-for="(item,index) in subjectList" :class="index==activeIndex?'active-batch':''" :key="index" disabled>{{item.name}}</el-button> -->
            </el-form-item>
            <el-form-item label="选择批次：" prop="local_batch_type" class="local-batch-type-btns">
                <el-button v-for="(item,index) in batchList" :class="index==activeIndex1?'active-batch':''" :key="index" @click="changeActiveIndexHandler1(index, item.local_batch_id)">{{item.name}}</el-button>
            </el-form-item>
            <el-form-item label="高考总分：" prop="score">
                <el-input v-model.number="ruleForm.score" autocomplete="off" placeholder="请输入高考总分">
                    <template slot="append">分</template>
                </el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="teamInfoEditHandler">确定</el-button>
            <div><el-link :underline="false" @click="showGkInforHandler">取消</el-link></div>
        </div>
    </el-dialog>
</template>

<script>
import { teamInfoEdit } from '@/api/user'
import { mapState } from 'vuex'
export default {
    name: "Information",
    data() {
		const validateGrade = (rule, value, callback) => {
			if (value.length === 0) {
                callback(new Error("请输入高考总分"));
			} else {
			    if (!(/(^[1-9]\d*$)/.test(value)) || value > 750) {
				callback(new Error("请输入正确的高考总分"));
			    } else {
				callback();
			    }
			}
		};
		const validateRank = (rule, value, callback) => {
			if (value.length === 0) {
			    callback();
			} else {
			    if (!(/(^[1-9]\d*$)/.test(value))) {
				callback(new Error("请输入正确的排名"));
			    } else {
				callback();
			    }
			}
		};
        return {
			activeIndex: 0,
			activeIndex1: 0,
            addStatus: true,
            formLabelWidth: '105px',
            ruleForm: {
                province: localStorage.getItem("area"),
                province_name: '',
                local_type_id: '',
                subject_name: '',
                local_batch_type: '',
                score: '',
                section_line: '',
                year: '',
                subject_name: []
            },
            
            options: JSON.parse(sessionStorage.getItem('proInfo')),
            batchList: JSON.parse(sessionStorage.getItem('batchList')),
            subjectList: JSON.parse(sessionStorage.getItem('subjectList')),
            rules: {
                province:  [
                    { required: true }
                ],
                local_type_id:  [
                    { required: true }
                ],
                subject_name:  [
                    { required: true }
                ],
                local_batch_type:  [
                    { required: true }
                ],
                score: [
                    { required: true, trigger: 'blur', validator: validateGrade }
                ],
                section_line: [
                    { type: 'number',trigger: 'blur', validator: validateRank }
                ]
            }
        };
    },
    computed: { 
		...mapState({
		    gkInforObj: state => state.user.gkInforObj,
            provinceCode: state => state.user.provinceCode,
            // localTypeId: state => state.user.localTypeId,
            // subject_name: state => state.user.subject_name,
            // gk_year: state => state.user.gk_year,
		}),
    },
    watch: {
        // provinceCode (newVal) {
        //   this.ruleForm.province = newVal;
        // },
        // localTypeId (newVal) {
        //   this.ruleForm.local_type_id = String(newVal);
        // },
        // subject_name (newVal) {
        //   this.ruleForm.subject_name = newVal;
        // },
        // gk_year(newVal) {
        //   this.ruleForm.year = newVal;
        // },
  },
	mounted() {
        const gkInforObj = this.$store.state.user.gkInforObj;
        // console.log(gkInforObj)
        // if(gkInforObj.subject_name.length == 2) {
        //     gkInforObj.subject_name = gkInforObj.subject + ',' + gkInforObj.subject_name
        // }
        
        localStorage.setItem("isProvince","false");
        if(JSON.stringify(gkInforObj) != "{}" && gkInforObj) {
            this.ruleForm = {...gkInforObj};
            this.ruleForm.province = localStorage.getItem("area");
            this.ruleForm.province_name = this.options.filter(val => { return val.area === this.ruleForm.province})[0].name
            if(gkInforObj.local_type_id == 2 || gkInforObj.local_type_id == 4) {
                this.activeIndex = 1;
            } else {
                this.activeIndex = 0;
            }
            const batch_tmp = this.batchList.findIndex(val => { return val.local_batch_id == gkInforObj.local_batch_type });
            this.activeIndex1 = Number(batch_tmp)
            this.addStatus = false;
        } else {
            // this.ruleForm.local_type_id = this.localTypeId;
            // this.ruleForm.subject_name = this.subject_name;
            // this.ruleForm.year = this.gk_year;
        }
	},
    methods: {
		showGkInforHandler() {
			this.$store.commit('user/SHOWGKINFOR',false);
            localStorage.setItem("isEdit","false");
		},
		changeActiveIndexHandler(index,id) {
			this.activeIndex = index;
			this.ruleForm.local_type_id = id;
		},
		changeActiveIndexHandler1(index, local_batch_type) {
			this.activeIndex1 = index;
			this.ruleForm.local_batch_type = local_batch_type
		},
		teamInfoEditHandler() {
			this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    let {score, local_type_id, local_batch_type, year, subject_name } = this.ruleForm;
                    if(!this.ruleForm.year) {
                        year = new Date().getFullYear()
                        if(new Date().getMonth() > 7) {
                            year = (new Date().getFullYear()) + 1
                        }
                    }
                    teamInfoEdit(score, local_type_id, local_batch_type, year, subject_name).then(res => {
                        // this.$message({
                        //     message: '修改成功',
                        //     type: 'success'
                        // });
                        this.$store.commit('user/SHOWGKINFOR',false);
                        localStorage.setItem("isEdit","true");
                    })
            }
			})
		},
    }
}
</script>

<style lang='scss' scoped>
.dialog-box {
    img {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 40px;
        top: 40px;
    }
    p {
        font-size: 14px;
        color: #fe9f0a;
        margin: 6px 0;
        line-height: 20px;
        letter-spacing: 0.5px;
    }
    .dialog-province {
        margin-bottom: 20px;
    }
    .infor-text {
        display: flex;
        justify-content: space-between;
    }
    .dialog-footer {
        padding: 0;
        button {
            width: 496px;
            height: 52px;
            background: linear-gradient(90deg,#ffa94a, #ff913c)!important;
            border-radius: 8px;
            margin: 0 auto;
            font-size: 18px!important;
            color: #ffffff!important;
            position: absolute;
            bottom: 80px;
            left: 50%;
            border: none;
            transform: translateX(-50%);
            font-weight: 400;
        }
    }
}
</style>